import {ElementType} from "react";
import Product from "./dropdowns/Product";
import Customers from "./dropdowns/Customers";
import About from "./dropdowns/About";
import Resources from "./dropdowns/Resources";

export type LinkPage = {type: "link"; text: string; href: string};
export type DropdownPage = {
  type: "dropdown";
  text: string;
  href?: string;
  dropdown: ElementType;
  strapline?: string;
  w?: string;
};
export type Page = LinkPage | DropdownPage;

const Links: Page[] = [
  {
    type: "dropdown",
    text: "Product",
    dropdown: Product,
    w: "680px",
  },
  {
    type: "dropdown",
    text: "Resources",
    href: "/blog",
    dropdown: Resources,
    w: "500px",
  },
  {
    type: "dropdown",
    text: "Customers",
    href: "/customers",
    dropdown: Customers,
    w: "500px",
  },
  {
    type: "dropdown",
    text: "About",
    href: "/about",
    dropdown: About,
  },
];

export default Links;
